import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { SimulationsResponse } from '../../../types/API'

interface ExecutionsRevertedChartProps {
  data: SimulationsResponse
}

const ExecutionsRevertedChart: React.FC<ExecutionsRevertedChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const [date, { executionReverted }] of Object.entries(data)) {
    if (lineData[date]) {
      lineData[date] += executionReverted
    } else {
      lineData[date] = executionReverted
    }
    if (executionReverted) {
      totalizer += executionReverted
    }
  }

  const processData = () => {
    const allDateLabels = Object.keys(data)
    allDateLabels.sort()
    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Reverted Executions',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgb(252,20,82)',
        backgroundColor: 'rgba(211,25,40,0.82)',
        pointBackgroundColor: 'rgb(252,20,82)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgb(252,20,82)',
        pointHoverBorderColor: 'rgb(252,20,82)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Reverted Executions {totalizer > 0 && <Tot>Total: {totalizer}</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgb(252, 20, 82);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default ExecutionsRevertedChart
